"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreFinalizeStepCommandToJSON = exports.PreFinalizeStepCommandFromJSONTyped = exports.PreFinalizeStepCommandFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function PreFinalizeStepCommandFromJSON(json) {
    return PreFinalizeStepCommandFromJSONTyped(json, false);
}
exports.PreFinalizeStepCommandFromJSON = PreFinalizeStepCommandFromJSON;
function PreFinalizeStepCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'enrollmentLocationId': !runtime_1.exists(json, 'enrollmentLocationId') ? undefined : json['enrollmentLocationId'],
        'creditCard': !runtime_1.exists(json, 'creditCard') ? undefined : _1.CreditCardFromJSON(json['creditCard']),
        'promoCode': !runtime_1.exists(json, 'promoCode') ? undefined : json['promoCode'],
    };
}
exports.PreFinalizeStepCommandFromJSONTyped = PreFinalizeStepCommandFromJSONTyped;
function PreFinalizeStepCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'enrollmentLocationId': value.enrollmentLocationId,
        'creditCard': _1.CreditCardToJSON(value.creditCard),
        'promoCode': value.promoCode,
    };
}
exports.PreFinalizeStepCommandToJSON = PreFinalizeStepCommandToJSON;
//# sourceMappingURL=PreFinalizeStepCommand.js.map